const parse = (raw) => (raw ? { ...raw } : null);

export default {
  parse,
};
